import React, { useEffect, useState } from "react";
import { CircularProgressbarWithChildren, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "./LoadingFadeIn.css";
import brandsSettings from "./brandsSettings.json";
const BrandLoading = ({ brand }) => {
  const [progress, setProgress] = useState(0);
  const settings = brandsSettings[brand.toLowerCase()];
  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 1;
      });
    }, 30);
    return () => clearInterval(interval);
  }, []);
  return (
    <div className="loader-container">
      <div className="loader-wrapper">
        <CircularProgressbarWithChildren value={progress} styles={buildStyles(settings.style)}>
          <img src={settings.src} alt="Logo" className="loader-logo" />
        </CircularProgressbarWithChildren>
      </div>
    </div>
  );
};
export default BrandLoading;
